export default __webpack_public_path__ + "static/media/products_illstn.f6b3fc33.png";